import Router from "./Router";
import NavigationProvider from "./dataManager/provider/NavigationProvider";
import ModalProvider from "./dataManager/provider/modalProvider";
import CurrentAdminProvider from "./dataManager/provider/currentAdminProvider";
import CategoriesProvider from "./dataManager/provider/categoriesProvider";
import ProductsProvider from "./dataManager/provider/productsProvider";
import SearchProvider from "./dataManager/provider/searchProvider";
import UserProvider from "./dataManager/provider/usersProvider";

function App() {
  return (
    <NavigationProvider>
      <CurrentAdminProvider>
        <CategoriesProvider>
          <ProductsProvider>
            <SearchProvider>
              <UserProvider>
                <ModalProvider>
                  <Router />
                </ModalProvider>
              </UserProvider>
            </SearchProvider>
          </ProductsProvider>
        </CategoriesProvider>
      </CurrentAdminProvider>
    </NavigationProvider>
  );
}

export default App;
